import React, { PropsWithChildren, RefObject } from 'react';

type ListItemProps = PropsWithChildren<{
  clickHandler: React.MouseEventHandler<HTMLDivElement>;
  selected: boolean;
  id: string;
  idPostFix: string;
  reference?: RefObject<HTMLDivElement | null>;
}>;

function ListItemContainer({ clickHandler, selected, id, idPostFix, reference, children }: ListItemProps) {
  return (
    // this does not have to be an <li>, semantics come from role="option"
    <div
      ref={reference}
      key={`combobox-option-${id}-${idPostFix}`}
      onMouseDown={clickHandler}
      className="combobox__listbox-item"
      role="option" // important! don't change
      aria-selected={selected}
      id={`combobox-option-${id}-${idPostFix}`}
      tabIndex={-1}
    >
      <div className="combobox__list-item-container">{children}</div>
    </div>
  );
}

export default ListItemContainer;
